import { Grid } from "antd";
import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";
import ArrowUp from "../assets/images/icons/ArrowUp";
import { ScrollContextType } from "./data";
import styles from "./styles.module.scss";

const ScrollContext = createContext<ScrollContextType>({ isTop: true });

type ScrollContextProviderType = PropsWithChildren & {};

export const ScrollContextProvider = ({
  children,
}: ScrollContextProviderType) => {
  const [isTop, setIsTop] = useState<boolean>(true);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  useEffect(() => {
    console.debug("isTop", isTop);
  }, [isTop]);

  useEffect(() => {
    const handleScroll = () => {
      let element = document.getElementById("main-layout");
      if (!element) return;

      const scrollTop = element.scrollTop; //滚动条滚动高度
      if (scrollTop > 0) {
        setIsTop(false);
      } else {
        setIsTop(true);
      }
    };
    // 监听
    window.addEventListener("scroll", handleScroll, true);
    // 销毁
    return () => window.removeEventListener("scroll", handleScroll, true);
  }, []);

  const handleScrollTop = () => {
    const element = document.getElementById("main-layout");
    if (element) {
      element.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <ScrollContext.Provider value={{ isTop }}>
      {children}
      {isTop === false ? (
        <div
          className={`${styles.topButon} ${screens.sm ? "" : styles.mobile}`}
          onClick={handleScrollTop}
        >
          <ArrowUp style={{ color: "var(--primary)", fontSize: 24 }} />
        </div>
      ) : null}
    </ScrollContext.Provider>
  );
};

export const useScroll = () => {
  const LoadingValue = useContext(ScrollContext);
  return LoadingValue;
};
